(function () {
  'use strict';

  angular
    .module('virtualFairs')
    .controller('EditModalAddEventDataController', EditModalAddEventDataController)

  EditModalAddEventDataController.$inject = ['$uibModalInstance', 'virtualFair', 'VirtualFairService', '$rootScope'];

  function EditModalAddEventDataController($uibModalInstance, virtualFair, VirtualFairService, $rootScope) {
    var vm = this;

    vm.virtualFair = virtualFair;
    vm.virtualFairEdit = {};
    vm.ok = ok;
    vm.cancel = cancel;
    vm.update = update;
    vm.errors = false;

    vm.logicOptions = [
      {id: 0, name: 'No'},
      {id: 1, name: 'Yes'}
    ];

    activate();

    function activate() {
      vm.virtualFairEdit = Object.assign([], vm.virtualFair);
    }

    function ok () {
      $uibModalInstance.close();
    }

    function cancel () {
      $uibModalInstance.close();
    }

    function update() {
      vm.errors = false;
      vm.data = {};
      vm.data['id'] = vm.virtualFairEdit.id;
      vm.data['platform_fair_id'] = vm.virtualFairEdit.platform_fair_id;
      vm.data['platform_fair_code'] = vm.virtualFairEdit.platform_fair_code;
      vm.data['platform_prefix'] = vm.virtualFairEdit.platform_prefix;
      vm.data['exhibitor_login_url'] = vm.virtualFairEdit.exhibitor_login_url;
      vm.data['open_exhibitor_login'] = vm.virtualFairEdit.open_exhibitor_login;

      VirtualFairService.updateEventData(vm.data).then(function(response){
        alertify.notify(response, 'success', 3);
        $uibModalInstance.close(vm.virtualFairEdit);
      }).catch(function(err) {
        vm.errors = err.data;
        alertify.notify(err, 'danger', 3);
      });
    }
  }

})();